
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppDateTimePicker } from '@/components';
import { usePromotionCodeAdd } from '@/modules/promotion/code/model/add';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.CODE.ADD,
    components: { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppDateTimePicker },
    setup() {
        const { model, v$, create, Options } = usePromotionCodeAdd();

        return { model, v$, create, Options };
    }
});
